import { useState } from "react";
import api, { apiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export const LeadPrice = ({ m, onSaved }) => {
  const [v, setV] = useState(m.price ?? 15);
  const editable = m.status === "available" || m.status === "withdrawn";
  if (!editable) return <span className="text-sm">${Number(m.price_paid ?? m.price ?? 0).toFixed(2)}{m.auto_assigned && <div className="text-xs text-emerald-700">Auto-assigned free</div>}</span>;
  const save = async () => {
    try { await api.post(`/admin/marketplace/leads/${m.id}/price`, { price: parseFloat(v) }); toast.success("Price updated"); onSaved(); }
    catch (e) { toast.error(apiError(e)); }
  };
  return (
    <div className="flex items-center gap-1">
      <span className="text-slate-400">$</span>
      <Input type="number" step="0.01" min="0" value={v} onChange={(e) => setV(e.target.value)} className="h-8 w-20" data-testid={`market-price-${m.id}`} />
      {Number(v) !== Number(m.price) && <Button size="sm" variant="ghost" onClick={save} data-testid={`market-price-save-${m.id}`}>Save</Button>}
    </div>
  );
};
